"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _4d_mapper_1 = require("4d-mapper");
const rxjs_1 = require("rxjs");
const Cesium = window.Cesium;
/**
 * an implmentation speicifc coordinate. Contains untis to convert from cesium to standard coords
 * as well as placeholders for holding the cesium cartesian coords so they dont need to be recalced
 */
class ArcGisTransformRenderer extends _4d_mapper_1.Renderer {
    constructor(viewer) {
        super();
        this.viewer = viewer;
        this._log();
    }
    onAdd(t, args) {
        var url = t.file('ArcGis');
        var layer = t['proxyMeta'].layer_id;
        this._log('onAdd', [t, args, url, layer]);
        if (args && args.onInit) {
            args.onInit(t);
        }
        var esri = new Cesium.ArcGisMapServerImageryProvider({
            url: url,
            layers: layer
        });
        if (esri.errorEvent) {
            this.monitorEvent('errorEvent', esri.errorEvent);
        }
        if (args && args.onStart) {
            args.onStart(t, esri);
        }
        var obj = this.viewer.imageryLayers.addImageryProvider(esri);
        if (args && args.onEnd) {
            args.onEnd(t, obj);
        }
        var pr = {
            plottable: t,
            object: obj
        };
        return rxjs_1.of(pr);
    }
    onRemove(t, pr) {
        this.viewer.imageryLayers.remove(pr.object);
    }
}
exports.ArcGisTransformRenderer = ArcGisTransformRenderer;
